import * as React from "react";
const SvgFiRrBolt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bolt_svg__a)">
      <path
        fill="#062147"
        d="M11.24 24a2.3 2.3 0 0 1-.948-.212 2.18 2.18 0 0 1-1.2-2.622L10.653 16H6.975A3 3 0 0 1 4.1 12.131l3.024-10A2.98 2.98 0 0 1 10 0h3.693a2.6 2.6 0 0 1 2.433 3.511L14.443 8H17a3 3 0 0 1 2.483 4.684l-6.4 10.3A2.2 2.2 0 0 1 11.24 24M10 2a1 1 0 0 0-.958.71l-3.024 10A1 1 0 0 0 6.975 14H12a1 1 0 0 1 .957 1.29l-1.947 6.442a.183.183 0 0 0 .121.241.19.19 0 0 0 .27-.073l6.4-10.3a1 1 0 0 0 .077-1.063A.98.98 0 0 0 17 10h-4a1 1 0 0 1-.937-1.35l2.19-5.841a.6.6 0 0 0-.56-.809z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bolt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBolt;
